import { DataLayerEvent, pushEvent } from '@/modules/datalayer/helpers'

const $ = require('jquery')
const moment = require('moment')

const { BREAKPOINT } = require('./api')

const CampaignTimer = {
  init () {
    this.$campaignTimer = $('#campaignTimer')
    this.$campaignEndTime = $('.campaign-wrapper--timer').attr('data-campaign-time')
    this.$timerBar = this.$campaignTimer.find('.timer-bar')
    this.timerBarState = false
    this.pageScrolled = false
    const _ = this

    function showComponent () {
      _.timerConfiguration()
      _.componentOnResize()

      /* eslint-disable */
      const buttonCta = $('#campaignTimer').find('.btn-cta')
      if (buttonCta) {
        const eventData = {
          promotion_id: buttonCta.data('name'),
          promotion_name: buttonCta.data('name'),
          creative_name: buttonCta.data('name') + '_campaign',
          creative_slot: 'campaign',
        }
        const [ event ] = DataLayerEvent.viewPromotion(eventData)
        pushEvent(event)
        buttonCta.on('mousedown', () => {
          const [ event ] = DataLayerEvent.selectPromotion(eventData)
          pushEvent(event)
        })
      }
      /* eslint-enable */

      $(document).on('readystatechange', function() {
        show()
      })
    }

    function show () {
      if (document.readyState === 'complete') {
        if (window.innerWidth < BREAKPOINT.TABLET) {
          _.showCampaignTimerOnMobile()
        } else {
          _.showCampaignTimerOnHigherRes()
        }
      }
    }

    this.shouldComponentStart().then(function(anyCampaign) {
      if (anyCampaign) {
        return showComponent()
      } else {
        return null
      }
    }).catch(function(err) {
      log.error(err)
    })
  },
  shouldComponentStart () {
    const eventTime = moment(this.$campaignEndTime, 'YYYY-MM-DD HH:mm:ss').unix()
    const currentTime = moment().unix()
    const diffTime = eventTime - currentTime
    const _ = this

    return new Promise(function(resolve) {
      if (diffTime > 0 || _.$campaignTimer.hasClass('campaignTimer_experienceEdit')) {
        resolve(true)
      }
    })
  },
  showCampaignTimerOnMobile () {
    $('header').prepend(this.$campaignTimer).css({ height: 115, marginTop: -60 })
    this.$campaignTimer.addClass('atTop')
    this.$timerBar.show()

    $('header').animate({ marginTop: 0 }, 1000)

    this.timerBarState = true
    this.onPageScroll()
  },
  showCampaignTimerOnHigherRes () {
    this.$campaignTimer.addClass('tightTimer').show()
    const _ = this

    if ((window.innerWidth > BREAKPOINT.TABLET) && (window.innerWidth < BREAKPOINT.DESKTOP)) {
      const t = setTimeout(function() {
        _.$timerBar.animate({ top: 60 }, 1000)
        clearTimeout(t)
      }, 1000)
    }

    if (window.innerWidth > BREAKPOINT.DESKTOP) {
      const t = setTimeout(function() {
        _.$timerBar.animate({ top: 75 }, 1000)
        clearTimeout(t)
      }, 1000)
    }

    this.onPageScroll()
  },
  hideCampaignTimer () {
    const _ = this

    $('header').animate({ marginTop: -60 }, 1000, function() {
      $(this).css({ height: 55, marginTop: 0 })
      _.showTimerBar()
    })
  },
  showTimerBar () {
    $('#stage').prepend(this.$campaignTimer)
    $('header .logo').addClass('scroll-logo')

    this.$campaignTimer.removeClass('atTop').animate({ top: 0 }, 500)
  },
  timerConfiguration () {
    const eventTime = moment(this.$campaignEndTime, 'YYYY-MM-DD HH:mm:ss').unix()
    const currentTime = moment().unix()
    const diffTime = eventTime - currentTime
    const duration = moment.duration(diffTime * 1000)
    const interval = 1000

    return this.setupTimer(duration, interval)
  },
  setupTimer (duration, interval) {
    const _ = this
    const htmlElem = {
      days: this.$timerBar.find('.box.days .num'),
      hours: this.$timerBar.find('.box.hours .num'),
      minutes: this.$timerBar.find('.box.minutes .num'),
      seconds: this.$timerBar.find('.box.seconds .num'),
    }

    const timer = function(cb) {
      setInterval(function() {
        duration = moment.duration(duration - interval)
        let days = moment.duration(duration).asDays().toString().split('.')[0]
        let hours = moment.duration(duration).hours()
        let minutes = moment.duration(duration).minutes()
        let seconds = moment.duration(duration).seconds()

        days = $.trim(days).length === 1 ? `0${days}` : days
        hours = $.trim(hours).length === 1 ? `0${hours}` : hours
        minutes = $.trim(minutes).length === 1 ? `0${minutes}` : minutes
        seconds = $.trim(seconds).length === 1 ? `0${seconds}` : seconds

        const dateSetup = {
          days: days.toString(10),
          hours: hours.toString(10),
          minutes: minutes.toString(10),
          seconds: seconds.toString(10),
        }

        for (const prop in htmlElem) {
          htmlElem[prop].find('.units').removeClass('changing')
          htmlElem[prop].find('.dozens').removeClass('changing')
        }

        if (duration <= 0) {
          return _.$campaignTimer.hasClass('campaignTimer_experienceEdit')
            ? _.$campaignTimer.show()
            : _.$campaignTimer.hide()
        } else {
          _.updateCounterValues(htmlElem, dateSetup)
          _.moveDaysSecondsBlock(htmlElem, dateSetup)
          cb(htmlElem, dateSetup)
          return null
        }
      }, interval)
    }

    return timer(function(htmlElem, dateSetup) {
      setTimeout(function() {
        _.calculateBlockAnimation(htmlElem, dateSetup)
      }, 200)
    })
  },
  updateCounterValues (elems, dateSetup) {
    const setDozensValues = function(num, prop) {
      const nextNum = num === 0 ? 5 : num - 1

      elems[prop].find('.dozens div').first().text(num)
      elems[prop].find('.dozens div').last().text(nextNum)
    }

    const setUnitsValues = function(num, prop) {
      const nextNum = num === 0 ? 9 : num - 1

      elems[prop].find('.units div').first().text(num)
      elems[prop].find('.units div').last().text(nextNum)
    }

    for (const prop in dateSetup) {
      const splittedNum = dateSetup[prop].split('').map(function(results) {
        return parseInt(results)
      })

      setDozensValues(splittedNum[0], prop)
      setUnitsValues(splittedNum[1], prop)
    }
  },
  moveDaysSecondsBlock (elems, dateSetup) {
    if (dateSetup.days === '00') {
      elems.days.parent().hide()
      elems.seconds.parent().show()
    }
  },
  calculateBlockAnimation (elems, dateSetup) {
    const animateSeconds = function(minutes) {
      const seconds = parseInt(dateSetup.seconds)
      elems.seconds.find('.units').addClass('changing')

      if (seconds % 10 === 0) {
        elems.seconds.find('.dozens').addClass('changing')
      }

      if (seconds === 0) {
        minutes(animateHours)
      }
    }

    const animateMinutes = function(hours) {
      const minutes = parseInt(dateSetup.minutes)
      elems.minutes.find('.units').addClass('changing')

      if (minutes % 10 === 0) {
        elems.minutes.find('.dozens').addClass('changing')
      }

      if (minutes === 0) {
        hours(animateDays)
      }
    }

    const animateHours = function(days) {
      const hours = parseInt(dateSetup.hours)
      elems.hours.find('.units').addClass('changing')

      if (hours % 10 === 0) {
        elems.hours.find('.dozens').addClass('changing')
      }

      if (hours === 0) {
        days()
      }
    }

    const animateDays = function() {
      const days = parseInt(dateSetup.days)
      elems.days.find('.units').addClass('changing')

      if (days % 10 === 0 || days === 0) {
        elems.days.find('.dozens').addClass('changing')
      }
    }

    return animateSeconds(animateMinutes)
  },
  onPageScroll () {
    const _ = this

    // Musi się uruchamiać tylko raz dla każdego zwrotu
    $(window).scroll(function() {
      if ($(window).scrollTop() > 0 && _.pageScrolled === false) {
        $('header .logo').addClass('scroll-logo')

        if (window.innerWidth < BREAKPOINT.TABLET) {
          _.hideCampaignTimer()
          _.pageScrolled = true
        } else {
          _.$campaignTimer.removeClass('tightTimer')
          _.pageScrolled = true
        }
      } else if ($(window).scrollTop() > 0 && _.pageScrolled === true) {
        if (window.innerWidth > BREAKPOINT.TABLET) {
          _.$campaignTimer.removeClass('tightTimer')
        }
      } else if ($(window).scrollTop() === 0) {
        if (window.innerWidth > BREAKPOINT.TABLET) {
          _.$campaignTimer.addClass('tightTimer')
        }
      }
    })
  },
  componentOnResize () {
    const _ = this

    $(window).resize(function() {
      _.timerBarState = true

      if (window.innerWidth > BREAKPOINT.TABLET) {
        _.$timerBar.css({ top: 60 })
      }

      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        _.$timerBar.css({ top: 75 })
      }
    })
  },
}

module.exports = CampaignTimer



// WEBPACK FOOTER //
// ./src/modules/campaignTimer.js